import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {HEART__24, HEART__16} from '@homeaway/svg-defs';

export class Scratchpad extends React.Component {
    render() {
        const {label, iconSize, tripboard} = this.props;
        const scratchpadLink = (
            <div className="site-header-nav__scratchpad" data-bypass="true">
                <SVGIcon inlineFlex markup={iconSize === 'sm' ? HEART__16 : HEART__24}/>
                <span className="site-header-nav__icon-label">{label}</span>
            </div>
        );
        if (tripboard) {
            return tripboard({scratchpadLink});
        }
        return scratchpadLink;
    }
}
